import React from 'react';
import { Link, Text } from '@goodfynd/react-web.lib.ui';

import strings from '../../../config/strings';

import { StyledContainer, StyledPosition } from './styles';

type OpenPosition = {
  location: string;
  title: string;
  url?: string;
};

const renderPosition = ({
  url = 'https://www.indeed.com/cmp/Goodfynd.com/jobs',
  ...position
}: OpenPosition) => (
  <StyledPosition>
    <Link href={url} target="_blank">
      <Text as="subhead2" inherit>
        {position.title}
      </Text>
    </Link>

    <Text as="body2">{position.location}</Text>
  </StyledPosition>
);

export default function PanelJoin() {
  return (
    <StyledContainer>
      <Text as="heading3" style={{ marginBottom: 16 }}>
        {strings.titles.joinTheTeam}
      </Text>

      <Text
        style={{
          marginBottom: 32,
        }}
      >
        If you are a self starter interested in making an impact for an amazing
        community of mobile business owners and operators, we look forward to
        hearing from you.
      </Text>

      <Text as="heading5" style={{ marginBottom: 16 }}>
        {strings.titles.openPositions}
      </Text>

      {renderPosition({
        title: 'Customer Experience Manager',
        location: 'Alexandria, VA',
      })}

      {renderPosition({
        title: 'Customer Experience Manager',
        location: 'Richmond, VA',
      })}

      {renderPosition({
        title: 'Back-End Engineer',
        location: 'Remote',
        url: 'https://www.indeed.com/viewjob?jk=d641c38c17664497',
      })}

      {renderPosition({
        title: 'Front-End Engineer',
        location: 'Remote',
        url: 'https://www.indeed.com/viewjob?jk=ad18f51a9fcdfa9c',
      })}

      {renderPosition({
        title: 'QA/Automations Engineer',
        location: 'Remote',
        url: 'https://www.indeed.com/viewjob?jk=7a41891a4731bec0',
      })}
    </StyledContainer>
  );
}
